
import { Vue } from "vue-class-component";

export default class Cargo extends Vue {}
